export enum AppRole {
  BackOfficeAdmin = 'AlertBackOfficeAdmin',
}
